import { fetchJSON } from "../framework/api";
import * as Popup from "../framework/components/popup";
import * as Dialog from "../framework/dialog";
import { filestackPicker } from "../framework/uploader";
import { getUITranslation } from "../utils/get_ui_translation";
import { getParam, setParam } from "../framework/query";

document.addEventListener("DOMContentLoaded", function () {
  const customerSelect = document.getElementById("js-skills-customer-select");
  if (customerSelect) {
    const showCustomerPanel = (customerId) => {
      document.querySelectorAll("[data-customer-panel]").forEach((panel) => {
        panel.hidden = panel.dataset.customerPanel !== String(customerId);
      });
    };

    const savedCustomer = getParam("customer");
    const isValidOption = [...customerSelect.options].some((o) => o.value === savedCustomer);

    if (savedCustomer && isValidOption) {
      customerSelect.value = savedCustomer;
      showCustomerPanel(savedCustomer);
    }

    customerSelect.addEventListener("change", (e) => {
      setParam("customer", e.target.value);
      showCustomerPanel(e.target.value);
    });
  }

  const postUrl = p`/ajax/documents/create`;

  document.querySelectorAll(".skills-documents-loader").forEach((skillsDocumentsLoader) => {
    const { trainingSessionId, customerId, type } = skillsDocumentsLoader.dataset;
    const loadButton = skillsDocumentsLoader.querySelector(".skills-documents-loader__open");
    const modalElt = skillsDocumentsLoader.querySelector(".skills-documents-loader__modal");
    const publishButton = modalElt.querySelector(".skills-documents-loader__publish");

    loadButton.addEventListener("click", async function (e) {
      e.preventDefault();

      try {
        const { filesUploaded: uploadedFiles } = await filestackPicker({
          path: "/documents/filestack/",
          maxSingleFileSize: null,
          maxFiles: 20,
          transformations: { crop: true, rotate: true, circle: true },
        });

        publishButton.disabled = true;
        Popup.open(modalElt);

        const files = uploadedFiles.map((blob) => {
          const { url, filename, size, mimetype: mime } = blob;
          return { url, filename, size, mime, type, training_session_id: trainingSessionId, customer_id: customerId };
        });

        const body = {
          files: JSON.stringify(files),
        };

        const waitElt = modalElt.querySelector(".skills-documents-loader__wait");
        const listElt = modalElt.querySelector(".skills-documents-loader__list");
        const templateElt = listElt.querySelector(".skills-documents-loader__list__item--template");

        uploadedFiles.forEach(({ url, filename, key: path }, index) => {
          let rowElt = templateElt.cloneNode(true);
          // The template class must not survive on the clone: otherwise, once the real template is removed at
          // the end of this handler, a subsequent upload picks up a leftover, already-indexed row as the
          // "template" and re-indexes its inputs again (e.g. target[0] becoming target[0][0]).
          rowElt.classList.remove("hidden", "skills-documents-loader__list__item--template");
          rowElt.querySelector(".skills-documents-loader__list__item__filename").innerText = filename;

          const targetSelect = rowElt.querySelector(".skills-documents-loader__list__item__target");
          const typeSelect = rowElt.querySelector(".skills-documents-loader__list__item__type");
          const traineeTypeSelect = rowElt.querySelector(".skills-documents-loader__list__item__trainee-type");

          setShowAndRequired(typeSelect, true);

          targetSelect.addEventListener("change", function (_event) {
            if (targetSelect.value == "all") {
              setShowAndRequired(typeSelect, true);
              setShowAndRequired(traineeTypeSelect, false);
            } else {
              setShowAndRequired(typeSelect, false);
              setShowAndRequired(traineeTypeSelect, true);
            }
          });
          [targetSelect, typeSelect, traineeTypeSelect].forEach((select) => {
            select.name = `${select.name}[${index}]`;
          });

          listElt.appendChild(rowElt);

          listElt.appendChild(createHiddenInput(`url[${index}]`, url));
          listElt.appendChild(createHiddenInput(`filename[${index}]`, filename));
          listElt.appendChild(createHiddenInput(`path[${index}]`, path));
        });

        templateElt.remove();

        const response = await fetchJSON(postUrl, { method: "POST", body });
        if (!response.success) {
          throw response.error;
        }

        waitElt.classList.toggle("hidden");
        listElt.classList.toggle("hidden");

        publishButton.disabled = false;
      } catch (e) {
        Popup.close(modalElt);

        console.error("Error during the documents loading", e);
        Dialog.alert("", getUITranslation("Erreur lors du chargement des documents."), "error");
      }
    });
  });
});

function setShowAndRequired(formField, on) {
  const wrapper = formField.closest(".js-skills-document-select-wrapper");
  formField.toggleAttribute("required", on);
  if (wrapper) {
    wrapper.classList.toggle("hidden", !on);
  } else {
    formField.classList.toggle("hidden", !on);
  }
}

function createHiddenInput(name, value) {
  const hiddenInput = document.createElement("input");
  hiddenInput.setAttribute("type", "hidden");
  hiddenInput.setAttribute("name", name);
  hiddenInput.value = value;
  return hiddenInput;
}
